// Watches the hidden <input type="file"> inside the video upload container.
// When the user picks a file, generates an ObjectURL and swaps the dropzone
// for a <video controls> element so they can preview playback immediately.
export const VideoPreview = {
  mounted() {
    const input = this.el.querySelector("input[type='file']") as HTMLInputElement | null
    const video = this.el.querySelector("#video-preview-el") as HTMLVideoElement | null
    const placeholder = this.el.querySelector("#video-upload-placeholder") as HTMLElement | null
    const previewWrap = this.el.querySelector("#video-preview-wrap") as HTMLElement | null

    if (!input || !video) return

    let objectUrl: string | null = null

    // LiveView controls show/hide via assigns; hook only manages the ObjectURL src.
    const applyFile = (file: File) => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
      objectUrl = URL.createObjectURL(file)
      video.src = objectUrl
      video.load()
    }

    input.addEventListener("change", () => {
      const file = input.files?.[0]
      if (file) applyFile(file)
    })

    this.handleEvent("video:reset", () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
        objectUrl = null
      }
      video.removeAttribute("src")
      video.load()
    })
  },

  destroyed() {
    // ObjectURLs leak if we don't clean up on unmount.
    // Nothing we can do from a static reference here, browser will reclaim on nav.
  },
}
